// DS: i3.31
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import IconWrap from '../../IconWrap';
const Copy = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _object_spread_props(_object_spread({}, props), {
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 11a1 1 0 01-1 1H5a1 1 0 01-1-1V2a1 1 0 011-1h7.1a1 1 0 01.63.33l2.02 2.39a1 1 0 01.25.66V11zm-5-8H6v7h7V6h-2a1 1 0 01-1-1V3zM2 4h1v9h9v1a1 1 0 01-1 1H2a1 1 0 01-1-1V5a1 1 0 011-1z",
        clipRule: "evenodd"
    })));
};
Copy.displayName = 'Copy';
export default Copy;

//# sourceMappingURL=Copy.js.map